import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { RunnerTargetSelectComponent } from '../../../components/runner-target-select/runner-target-select.component';
import type { RunTarget } from '../../../services/execution-job.service';

export interface StartRunnerRoundDialogData {
  projectId: string;
  runKey: string;
  runName: string | null;
}

/**
 * Rechnerwahl vor dem neuen Durchlauf eines Runner-Laufs (NEX-1601). Ergebnis ist das Ziel,
 * `undefined` heisst abgebrochen.
 *
 * <p><b>Ohne eigenen Design-Entwurf.</b> Das Bundle zeigt die Rechnerauswahl nur im
 * Ausfuehren-Dialog (page-testfaelle.jsx:364-470); hier steht derselbe Baustein ohne die
 * Art-Wahl, im Stil jenes Dialogs (Team-Absprache 05.10.).
 */
@Component({
  selector: 'app-start-runner-round-dialog',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    RunnerTargetSelectComponent,
    TranslatePipe,
  ],
  templateUrl: './start-runner-round-dialog.component.html',
  styleUrl: './start-runner-round-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartRunnerRoundDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<StartRunnerRoundDialogComponent, RunTarget>);
  readonly data = inject<StartRunnerRoundDialogData>(MAT_DIALOG_DATA);

  readonly target = signal<RunTarget | null>(null);

  start(): void {
    const target = this.target();
    if (target) {
      this.dialogRef.close(target);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
